import store from '../vuex/store'

const beforeEach = (to, from, next) => {
  const usuarioStore = store.getters.getUsuario
  const empresaStore = store.getters.getEmpresa
  if (!to.matched.length) {
    next({ path: '*' })
  } else {
    if ((to.meta.requiresLogin && !usuarioStore) || (to.meta.requiresLogin && !usuarioStore.cpf)) {
      next({ path: '/login' })
    } else if ((to.meta.requiresCompany && !empresaStore) || (to.meta.requiresCompany && !empresaStore.cnpj)) {
      next({ path: '/company' })
    } else {
      if (to.meta.permissions.some(x => x === empresaStore.idNivel) || to.meta.permissions.length === 0) {
        next()
      } else {
        console.error('Você não tem permissão para acessar esse módulo.')
        next({ path: '/' })
      }
    }
  }
}

export default beforeEach
